import { SubmissionError } from 'redux-form';
import { ADD_CAR_FORM_REQUIRED_FIELDS, ADD_TRAILER_FORM_REQUIRED_FIELDS, REQUIRED_FIELDS } from './constants';

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (!prev[key]) {
			prev[key] = {};
		}

		prev[key] = error;

		return prev;
	}, {});
};

export const validate = values => {
	REQUIRED_FIELDS.forEach(key => {
		if (!values?.[key] || values?.[key] === 'none') {
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};

export const validateCarForm = values => {
	ADD_CAR_FORM_REQUIRED_FIELDS.forEach(key => {
		if (!values?.[key]) {
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};

export const validateTrailerForm = values => {
	ADD_TRAILER_FORM_REQUIRED_FIELDS.forEach(key => {
		if (!values?.[key]) {
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
